const internalChatOverrides = {
  'merchantportal-gb': {
    tag: 'merchantportal-gb-internal',
    feature: 'meg.help-tool.chat.uk-internal'
  }
}

export default internalChatOverrides
